export default __webpack_public_path__ + "static/sentrydefault_1920x1080-a2c6fad7fa4dd70c24cd9a2f7d819ff5.jpg";